import qs from 'qs';
import axios from 'axios';
import adapterRequest from 'axios/lib/adapters/xhr';
import { Root } from 'protobufjs';
import { isDebug, isTestHttps, isMock, isTxEnv, REQUESTDOMAIN, project, curProject, pbENV } from 'CONFIG/config';
import { toISOString } from 'UTILS/utils';
import { browser } from 'UTILS/browser';

// 输出样式控制
const COMMON_STYLE = 'padding: 0 6px;color:#fff;border-radius: 4px;';
const ERR_STYLE = COMMON_STYLE + 'background-color:red;';
const SEND_STYLE = COMMON_STYLE + 'background-color:#FFCC00;';
const RECEIVE_STYLE = COMMON_STYLE + 'background-color:#66CC00;';
const TIME_STYLE = COMMON_STYLE + 'background-color:#FF9966;';
const TIME_STYLE_HEIGHTLIGHT = 'font-weight:bold;color:#FF0033;';
const TIME_STYLE_NORMAL = 'color:#000;';

// 请求统计数据,可以随时上报
const ajaxList = [];

// 统计个请求时长，测试所得耗时比console.time略好，而且自由度更高
const performanceData = (key, data) => {
  const { initTime, sendTime, receiveTime, finishTime } = data;
  const totalTime = finishTime - initTime;
  const networkTime = receiveTime - sendTime;
  const encodeTime = sendTime - initTime;
  const decodeTime = finishTime - receiveTime;
  // 保存统计数据
  ajaxList.push({
    key,
    totalTime,
    networkTime,
    encodeTime,
    decodeTime,
    initTime,
    sendTime,
    receiveTime,
    finishTime,
  });
  isDebug &&
    console.log(
      `%c${key}%c 总消耗时长：%c${totalTime}ms%c  网络时长：%c${networkTime}ms%c  encode时长：%c${encodeTime}ms%c  decode时长：%c${decodeTime}ms`,
      TIME_STYLE,
      TIME_STYLE_NORMAL,
      TIME_STYLE_HEIGHTLIGHT,
      TIME_STYLE_NORMAL,
      TIME_STYLE_HEIGHTLIGHT,
      TIME_STYLE_NORMAL,
      TIME_STYLE_HEIGHTLIGHT,
      TIME_STYLE_NORMAL,
      TIME_STYLE_HEIGHTLIGHT
    );
};

let root = null;
let mockData = null;

const isGzip = () => {
  if (browser.isIOS) return true;

  const ua = navigator.userAgent;
  const ary = ua.match(/.+Chrome\/(\d+).+Safari\/(\d+).*/i);
  if (!ary) {
    return false;
  }
  const chromeVersion = ary[1];
  return chromeVersion >= 40;
};

export const Axios = axios.create({
  timeout: 30000,
  responseType: 'arraybuffer',
  headers: {
    'Content-Type': 'application/protobuf',
  },
});

// Add a request interceptor
Axios.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    return config;
  },
  (err) => {
    // Do something with request error
    return Promise.reject(err.data.error.message);
  }
);

Axios.interceptors.response.use(
  (res) => {
    // Do something with response data
    return res;
  },
  (err) => {
    // Do something with response error
    return Promise.reject(err);
  }
);

let idx = 1;
export default (settings) => {
  if (!root) {
    throw '请先设置pb';
  }
  const curEnv = settings.pbENV || pbENV;
  const env = isTxEnv ? curEnv.replace('-tx', '') : curEnv;
  let defaults = {
    method: 'post',
    rpcInDesction: 'RPCInput',
    rpcOutDesction: 'RPCOutput',
    env,
    application: project,
    app: project,
    pbENV: pbENV,
    client: 'h5;h5;h5;4.6.0;1.0.0.0',
  };
  const opts = Object.assign(defaults, settings, { idx: idx++, initTime: +new Date() });
  const reqBuffer = encode(opts.reqDesction, opts.data || {});
  if (!reqBuffer) return Promise.reject(`${opts.funcName} encode fail!`);
  const rpcBuffer = encode(opts.rpcInDesction, {
    obj: opts.serverName,
    func: opts.funcName,
    req: reqBuffer,
    opt: Object.assign(
      {
        application: opts.application || project,
        app: opts.app || project,
        env,
        appid: typeof opts.appid !== 'undefined' ? opts.appid : curProject.appid,
        client: opts.client,
        'X-Token': opts.token || '', // 处理bindPhone
        roomid: opts.roomid || '', // 处理bindPhone
        deviceid: opts.deviceid || '', // 设备ID，站内一定传，站外不用传
      },
      opts.opt,
      opts.region ? { region: opts.region } : {} // region 为 CN-国内 或 INT-国外
    ),
  });

  if (!rpcBuffer) return Promise.reject(`${opts.funcName} encode fail!`);
  const keyName = opts.idx + ' ' + opts.funcName;

  // 开启log模式
  if (isDebug) {
    opts.sendTime = +new Date();
    console.log(`%c${keyName} params: `, SEND_STYLE, opts, toISOString());
  }

  // 返回模拟数据
  if (isMock && mockData && mockData[opts.funcName]) {
    isDebug && console.log(`${opts.funcName} mockData: `, mockData[opts.funcName]);
    return Promise.resolve(mockData[opts.funcName]);
  }

  // 线上调试https
  if (isTestHttps) {
    const str1 = opts.url.split('?');
    const str2 = str1[1].split('/');
    opts.url = `${str1[0]}${str2[1]}?${str2[0]}`;
  }

  return new Promise((resolve, reject) => {
    let headers = {
      'X-Token': opts.token || '',
      'accept-language': opts.lang || '*',
    };

    // 默认开启gzip, TODO 测试服都开gzip，正式服只有氧气有
    if (!isGzip && !curProject.gzipForbid && (curProject.autoGzip || (opts.pbENV !== 'prod' && pbENV !== 'prod'))) {
      headers['X-Accept-Encoding'] = 'original'; // original屏蔽gzip
    }

    Axios[opts.method](opts.url, rpcBuffer, {
      adapter: xhrAdapter,
      rpcBuffer,
      headers,
    })
      .then((res) => {
        opts.receiveTime = opts.finishTime = +new Date();
        if (res.status !== 200) {
          reject({
            message: '发生错误',
            description: res.data.message,
            requestOpt: opts,
            rpcOpt: rpcBuffer.opt,
            req: JSON.stringify(opts.data),
          });
        } else {
          const rpcOut = decode(opts.rpcOutDesction, new Uint8Array(res.data));
          if (!rpcOut) return Promise.reject(`${opts.funcName} decode fail!`);

          res.data = rpcOut.rsp ? decode(opts.resDesction, rpcOut.rsp) : {};
          if (!res.data) return Promise.reject(`${opts.funcName} decode fail!`);

          opts.finishTime = +new Date();

          if (rpcOut && rpcOut.ret === 0) {
            performanceData(keyName, opts);

            if (isDebug && res.data) {
              console.log(`%c${keyName} res: `, RECEIVE_STYLE, res.data, toISOString());
            }
            resolve(res.data);
          } else {
            const err = {
              env: opts.pbENV || pbENV,
              message: rpcOut.ret === 9999 ? `[${opts.funcName}]网络开小差了，请稍后再试~` : `[${opts.funcName}]${rpcOut.desc}`,
              description: rpcOut.desc,
              allDescription: rpcOut,
              requestOpt: opts,
              rpcOpt: rpcBuffer.opt,
              req: JSON.stringify(opts.data),
            };
            performanceData(keyName, opts);
            if (isDebug && res.data) {
              console.log(`%c${keyName} fail: `, ERR_STYLE, err, toISOString());
            }
            reject(err);
          }
        }
      })
      .catch((err) => {
        opts.receiveTime = opts.finishTime = +new Date();
        performanceData(keyName, opts);
        if (isDebug) {
          console.log(`%c${opts.idx} ${opts.funcName} err: `, ERR_STYLE, err, toISOString());
        }
        reject({
          env: opts.pbENV || pbENV,
          description: err.message,
          message: `[${opts.funcName}]网络开小差了，请稍后再试~~`,
          requestOpt: opts,
          rpcOpt: rpcBuffer.opt,
          req: JSON.stringify(opts.data),
        });
      });
  });
};

export const setPBName = (pbname, opts) => {
  root = Root.fromJSON(pbname);
  mockData = (opts && opts.mockData && opts.mockData.default) || {};
};

// 生成消息体
export const encode = (desction, data) => {
  const dataDesction = root.lookupType(desction);
  const err = dataDesction.verify(data);

  if (err) {
    return false;
  } else {
    const message = dataDesction.create(data);
    const buffer = dataDesction.encode(message).finish();
    return buffer;
  }
};

// 解析响应体
export const decode = (desction, data) => {
  const dataDesction = root.lookupType(desction);
  const err = dataDesction.verify(data);

  if (err) {
    return false;
  } else {
    const res = dataDesction.decode(data);
    const result = dataDesction.toObject(res, {
      defaults: true,
    });
    return result;
  }
};

function xhrAdapter(config) {
  config.data = config.rpcBuffer;
  return adapterRequest(config);
}

const formatParams = (acParams, method) => {
  // 标准化参数
  // https://github.com/axios/axios#browser
  // params = new URLSearchParams(params);
  if (method.toLowerCase() === 'post') {
    acParams = qs.stringify(acParams);
  }
  return acParams;
};

// 请求头
const formatHeaders = (acHeaders, method) => {
  let headers = {};

  if (method.toLowerCase() === 'post') {
    // 部分请求会出错，需要时人工添加
    headers['Content-type'] = 'application/x-www-form-urlencoded';
    // headers['Content-type'] = 'application/json';
    // headers['Content-type'] = 'application/protobuf';
  }

  if (acHeaders) {
    for (let i in acHeaders) {
      headers[i] = acHeaders[i];
    }
  }

  return headers;
};

/**
 * 普通异步请求
 * @params { String } 接口地址，必填
 * @params { Object } 请求头，可选
 * @params { String } 请求方式，get/post, 默认post
 * @params { String } oxygen
 * @params { Function } 上传回调，可选
 * @returns { Promise }
 */
export const httpReq = ({ url, headers, params, method, resType, rpcMsgName, onUploadProgress }) => {
  let prefix = REQUESTDOMAIN;

  // 默认post
  method = method || 'post';

  return new Promise((resolve, reject) => {
    let dataOrParams = 'data';

    // 仅允许get和post方法
    if (method.toLowerCase() !== 'get') {
      method = 'post';
    } else {
      dataOrParams = 'params';
    }

    // 如果是完成路径
    if (!/^(http|https):\/\/.*/.test(url)) {
      url = `${prefix}/${url}`;
    }

    return axios({
      url, //  vue-api本地
      method: method || 'post',
      responseType: resType || 'json', // 注意 arraybuffer 类型
      headers: formatHeaders(headers, method),
      [dataOrParams]: formatParams(params, method),
      onUploadProgress: onUploadProgress, // 上传进度
    })
      .then((data) => {
        if (resType === 'arraybuffer') {
          const rpcOut = decode(rpcMsgName, new Uint8Array(data.data));
          if (rpcOut) {
            return resolve(rpcOut);
          }
        }
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
        throw new Error(`Error:${err}`);
      });
  });
};

/**
 * HTTP RPC异步请求
 * @params { String } 接口地址，必填
 * @params { Object } 请求头，可选
 * @params { String } 请求方式，get/post, 默认post
 * @params { String } oxygen
 * @params { String } RPC Message 名称，如HSC100220
 * @params { Function } 上传回调，可选
 * @returns { Promise }
 */
export const httpRPCReq = ({ url, headers, params, method, hostType, rpcMsgName, onUploadProgress }) => {
  if (!root) {
    throw '请先设置pb';
  }
  // 返回类型不能变
  let resType = 'arraybuffer';

  // 看上去这类请求的message都是HSCXXXX
  rpcMsgName = rpcMsgName || `HSC${params.header}`;

  return new Promise((resolve, reject) => {
    httpReq({
      url,
      headers,
      params,
      method,
      hostType,
      resType,
      rpcMsgName,
      onUploadProgress,
    }).then(
      (data) => {
        resolve(data);
      },
      (err) => {
        reject(err);
      }
    );
  });
};
